import * as React from 'react';
import { compKey } from './key';
import { namespacedClassnames } from '../../common';
import { Text, Button, Icon, iconsMap } from '../../';
import { Container } from '../../primitives/container';
export function SettingsList(props) {
    var classNames = namespacedClassnames(compKey, props.className);
    var isEmptyState = props.items.length < 1;
    var emptyState = (React.createElement(Container, { className: 'empty-state' },
        React.createElement("div", { className: 'content' },
            React.createElement("div", { className: 'titles' },
                React.createElement(Text, { className: 'title', type: 'hsm', color: 't20' }, props.emptyStateContent.title),
                React.createElement(Text, { className: 'description', type: 't', color: 't30', html: props.emptyStateContent.description })),
            React.createElement(Button, { className: 'add-account-button', onClick: props.onCtaClick }, props.ctaText))));
    var addAccountButton = (React.createElement(Button, { type: 'tertiary', className: 'add-account-button under-list', onClick: props.onCtaClick },
        React.createElement(Icon, { icon: iconsMap.plusWithBg }),
        React.createElement("span", { className: 'add-page-text' }, props.ctaText)));
    var listItemView = function (item) { return React.createElement("li", { key: item.id, "data-id": item.id, className: 'list-item' }, props.renderItem(item)); };
    var list = React.createElement("ul", null, props.items.map(listItemView));
    return (React.createElement("div", { className: classNames },
        isEmptyState ? emptyState : list,
        !isEmptyState ? addAccountButton : null));
}
;
//# sourceMappingURL=index.js.map